import { render, staticRenderFns } from "./Dispositivos.vue?vue&type=template&id=6604060e&scoped=true"
import script from "./Dispositivos.vue?vue&type=script&lang=js"
export * from "./Dispositivos.vue?vue&type=script&lang=js"
import style0 from "./Dispositivos.vue?vue&type=style&index=0&id=6604060e&prod&lang=css"
import style1 from "./Dispositivos.vue?vue&type=style&index=1&id=6604060e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6604060e",
  null
  
)

export default component.exports